import type { TextColumnProps } from '@modules/page-builder/types';
import { RevampRichText } from './RevampRichText';
import { RevampProfessionalCtas } from './RevampProfessionalCtas';

interface RevampQuoteModuleProps {
    column: TextColumnProps;
    professional?: { title: string; link: string };
}

/**
 * Full-width pull quote (Figma "Page Builder / Quote / full"): left hairline,
 * 80px quote, the professional's name as the attribution and their CTA pills.
 * Attribution/CTAs are derived from the article's professional — the quote
 * module's CMS data is the text only.
 */
export const RevampQuoteModule = ({
    column,
    professional,
}: RevampQuoteModuleProps) => {
    return (
        <div className="w-full">
            <div className="ml-6 flex flex-col items-start gap-8 border-l border-solid border-black/20 pl-5 md:ml-[8.0625rem] md:gap-[3.875rem] md:pl-[1.5625rem]">
                <RevampRichText
                    contentHTML={column.contentHTML}
                    className="w-full font-sans text-[1.75rem] leading-[1.1] md:w-[72.5rem] md:max-w-full md:text-[5rem] md:leading-[1.1] md:tracking-[-0.03em]"
                />
                {professional?.title && (
                    <p className="m-0 font-sans text-[1.25rem] leading-[1.3] text-black opacity-80 md:text-[2rem] md:tracking-[-0.03em]">
                        ({professional.title})
                    </p>
                )}
                {professional && (
                    <RevampProfessionalCtas
                        professional={professional}
                        placement="quote"
                    />
                )}
            </div>
        </div>
    );
};
